import { Box, Button, Container, Grid, IconButton } from "@mui/material";
import { useState } from "react";
import { useQuery } from "react-query";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Iconify from "src/components/Iconify";
import Page from "src/components/Page";
import MRTTable from "src/components/mrt-table";
import useSettings from "src/hooks/useSettings";
import { getAllRider, masterGetData } from "src/pages/api";
import { PATH_DASHBOARD } from "src/routes/paths";
import AddRider from "./Add";
import WithoutPagination from "src/components/mrt-table/WithoutPagination";
import { HOST_API } from "src/config";
// import DeleteRecord from "../../DeleteRecord";
const columns = [
  {
    accessorKey: "fullName",
    header: "Rider Name",
  },
  {
    accessorKey: "code",
    header: "Code",
  },
  {
    accessorKey: "mobile",
    header: "Mobile No.",
  },
  {
    accessorKey: "doc_type",
    header: "Doc Type",
  },
  {
    accessorKey: "document_number",
    header: "Document Number",
  },
];

export default function DeliveryRider() {
  const { themeStretch } = useSettings();
  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const { data, isLoading } = useQuery({
    queryKey: ["getAllRider"],
    queryFn: getAllRider,
  });

  return (
    <>
      {open && (
        <AddRider
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
            setIsEditMode(false);
          }}
          row={selectedRow}
          isEditMode={isEditMode}
        />
      )}
      {/* {openDelete && (
        <DeleteRecord
          row={{ ...selectedRow, name: selectedRow.schoolName }}
          onClose={() => {
            setOpenDelete(false);
          }}
          tabeName={"schools"}
        />
      )} */}
      <Page title="Courier">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <HeaderBreadcrumbs
            heading={`Delivery Company Rider`}
            links={[
              { name: "Dashboard", href: PATH_DASHBOARD.root },
              {
                name: "Courier",
              },
              { name: "Rider" },
            ]}
          />
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <WithoutPagination
                data={data || []}
                columns={columns}
                loading={isLoading}
                renderRowActions={({ row }) => (
                  <Box sx={{ display: "flex" }}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setSelectedRow(row.original);
                        // setOpenView(true);
                        window.open(
                          `${HOST_API}images/riderDocument/${row.original?.filename}`,
                          "_blank"
                        );
                      }}
                      color="primary"
                      disabled={!row?.original?.filename}
                    >
                      <Iconify icon={"lets-icons:view"} />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setOpen(true);
                        setSelectedRow(row.original);
                        setIsEditMode(true);
                      }}
                      size="small"
                      color="primary"
                    >
                      <Iconify icon={"eva:edit-fill"} />
                    </IconButton>
                    {/* <IconButton
                      onClick={() => {
                        setOpenDelete(true);
                        setSelectedRow(row.original);
                      }}
                      color="error"
                      size="small"
                    >
                      <Iconify icon={"eva:trash-2-outline"} />
                    </IconButton> */}
                  </Box>
                )}
                renderTopToolbarCustomActions={() => (
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setOpen(true);
                      setIsEditMode(false);
                    }}
                  >
                    Add New
                  </Button>
                )}
              />
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
}
